import React from 'react';
import { AuthenticationLayout } from '../shared';
import {
  Box,
  Typography,
  Button,
  ErrorIcon,
  BackArrowIcon
} from '@invision/ui';
import { CircularProgress } from '@mui/material';
import { AUTHENTICATION_ROUTES } from '../../constants';
import { useHistory } from 'react-router';
import { useTranslation } from '@invision/core';

export function ExternalLoginCallback({
  isProcessing,
  error,
  onReturnToLogin
}: {
  isProcessing?: boolean;
  error?: string | null;
  onReturnToLogin?: () => void;
}) {
  const { t } = useTranslation();
  const history = useHistory();

  if (isProcessing) {
    return (
      <AuthenticationLayout>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="300px"
          textAlign="center"
        >
          <CircularProgress size={48} sx={{ mb: 3 }} />
          <Typography variant="h5" gutterBottom>
            {t('Completing Sign In')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t('Please wait while we process your authentication...')}
          </Typography>
        </Box>
      </AuthenticationLayout>
    );
  }

  if (error) {
    return (
      <AuthenticationLayout>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          sx={{ maxWidth: 500, mx: 'auto', py: 4 }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            <ErrorIcon sx={{ fontSize: 16, color: 'error.main', mr: 1.5 }} />
            <Typography variant="h2" color="error" sx={{ fontWeight: 600 }}>
              {t('Authentication Failed')}
            </Typography>
          </Box>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, maxWidth: 400, lineHeight: 1.6 }}
          >
            {error}
          </Typography>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => {
              onReturnToLogin?.();
              history.push(AUTHENTICATION_ROUTES.LOGIN);
            }}
            startIcon={<BackArrowIcon />}
            sx={{ py: 0.5 }}
          >
            {t('Return to Sign In')}
          </Button>
        </Box>
      </AuthenticationLayout>
    );
  }

  // This shouldn't render, but just in case
  return null;
}
